// Overlays (floating-ui popovers, dialogs, dropdowns, tooltips, and
// foundations-components Layer portals such as panels and drawers) render their
// content into a portal at the end of <body>. Two things follow from that:
//
//   - a document mousedown inside one looks like an "outside the table" click
//     even though the overlay was launched from a cell, and
//   - React replays synthetic events through the *React* tree, so a mousedown
//     inside an overlay portalled from a cell still reaches that cell's
//     onMouseDown handler.
//
// Both would otherwise let cell selection preventDefault the mousedown or clear
// the selection mid-interaction, which stops the overlay's inputs from ever
// receiving focus.
export const OVERLAY_SELECTOR = '[data-floating-ui-portal],[data-popover],[role="dialog"],[role="listbox"],[role="menu"],[role="tooltip"],[data-layer-for]';

/**
 * True when `target` sits inside an overlay. When `rootEl` is given (the cell
 * the handler belongs to), an overlay that *contains* the cell — e.g. the whole
 * table rendered inside a dialog — is not treated as an overlay interaction.
 */
export const isEventFromOverlay = (target, rootEl) => {
  if (!(target instanceof Element)) {
    return false;
  }
  const overlay = target.closest(OVERLAY_SELECTOR);
  if (!overlay) {
    return false;
  }
  return !(rootEl && overlay.contains(rootEl));
};